import React, { useState, useRef, useCallback } from "react";
import { AgGridReact } from "ag-grid-react"; // AG Grid Component
import ReactModal from "react-modal";

import { BsQuestionCircleFill } from "react-icons/bs";
import { FaFileDownload } from "react-icons/fa";

import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import "./deptStorage.css";

ReactModal.setAppElement("#root");
const DeptStorage = ({ deptDetails, deptStorageDetails }) => {
  const [showModal, setShowModal] = useState(false);

  const numberFormatter = (params) => {
    let value = Math.round((Number(params.value) + Number.EPSILON) * 100) / 100;
    let formatted = value
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return formatted + " MB";
  };

  const autoSizeStrategy = {
    type: "fitGridWidth",
    defaultMinWidth: 100,
  };

  const [colDefs] = useState([
    {
      field: "Course",
      filter: true,
      // suppressSizeToFit: false,
      // defaultMinWidth: 150,
      // width: 200,
    },
    { field: "Sections", suppressSizeToFit: true, width: 95 },
    {
      headerName: "Total Size",
      valueGetter: p => Number(p.data.Total_size) + Number(p.data.Archive_Files),
      // field: "Total_size",
      comparator: (valueA, valueB, nodeA, nodeB) => valueA - valueB,
      valueFormatter: numberFormatter,
      headerTooltip: "Total Size taken up by the course",
      // suppressSizeToFit: true,
    },
    
    // {
    //   headerName: "Audio Files",
    //   field: "Audio_Files",
    //   comparator: (valueA, valueB, nodeA, nodeB) => valueA - valueB,
    //   valueFormatter: numberFormatter,
    // },
    {
      headerName: "Course Files",
      field: "Course_Files",
      comparator: (valueA, valueB, nodeA, nodeB) => valueA - valueB,
      valueFormatter: numberFormatter,
      headerTooltip:
        "Files uploaded to the course by the instructor and subject to the quota requirement.",
      // suppressSizeToFit: true,
    },
    // {
    //   headerName: "Document Files",
    //   field: "Document_Files",
    //   comparator: (valueA, valueB, nodeA, nodeB) => valueA - valueB,
    //   valueFormatter: numberFormatter,
    // },
    // {
    //   headerName: "Image Files",
    //   field: "Image_Files",
    //   comparator: (valueA, valueB, nodeA, nodeB) => valueA - valueB,
    //   valueFormatter: numberFormatter,
    // },
    // {
    //   headerName: "Legacy Files",
    //   field: "Legacy_Files",
    //   comparator: (valueA, valueB, nodeA, nodeB) => valueA - valueB,
    //   valueFormatter: numberFormatter,
    //   headerTooltip:
    //     "Content from earlier versions of Blackboard, which can be recovered by using: 'Move Legacy Files to Course Files' in Packages and Utilities menu.",
    // },

    {
      headerName: "Student Files",
      field: "Protected_Files",
      comparator: (valueA, valueB, nodeA, nodeB) => valueA - valueB,
      valueFormatter: numberFormatter,
      headerTooltip:
        "Files uploaded by students - these do not count towards course quota, but video homework is often best uploaded to Panopto.",
      // suppressSizeToFit: true,
    },
    
    {
      headerName: "Files in Video Format",
      field: "Video_Files",
      comparator: (valueA, valueB, nodeA, nodeB) => valueA - valueB,
      valueFormatter: numberFormatter,
      suppressSizeToFit: true,
    },
    {
      headerName: "Zipped Files",
      field: "Archive_Files",
      comparator: (valueA, valueB, nodeA, nodeB) => valueA - valueB,
      valueFormatter: numberFormatter,
    },
    {
      headerName: "Other Files",
      field: "Other_Files",
      comparator: (valueA, valueB, nodeA, nodeB) => valueA - valueB,
      valueFormatter: numberFormatter,
      suppressSizeToFit: true,
      width: 120
      
    },
  ]);
  const handleOpenModal = () => {
    setShowModal(!showModal);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const gridRef = useRef();

  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  const onQuickFilterChanged = useCallback(() => {
    gridRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("quickFilter").value
    );
  }, []);
  // State to track whether it's in GB mode or MB mode

  return (
    <>
      <div className="dept-details-container">
        <div className="dept-storage-details">
          <p>
            Total Storage used by Course Code{" "}
            <b>{deptDetails[0].Course_Code.toUpperCase()}</b> :{" "}
            <b>
              {deptDetails[0].Size} MB or {deptDetails[0].Size / 1024} GB
            </b>
          </p>
        </div>
      </div>
      <div className="table-container">
        <div
          className="ag-theme-quartz" // applying the grid theme
          // style={{ maxHeight: 800 }} // the grid will fill the size of the parent container
        >
          <div className="search-container" >
                <label>
                  Search Course Code
                  <input
                    className="search-input"
                    // style={{
                    //   marginLeft: "5px",
                    //   borderRadius: "5px",
                    //   border: "3px",
                    // }}
                    type="text"
                    onInput={onQuickFilterChanged}
                    id="quickFilter"
                    placeholder="Search Course Code"
                  />
                </label>
              </div>
          <AgGridReact
            ref={gridRef}
            rowData={deptStorageDetails}
            columnDefs={colDefs}
            pagination={true}
            paginationPageSize={50}
            domLayout={"autoHeight"}
            tooltipShowDelay={0}
            alwaysShowHorizontalScroll={true}
            autoSizeStrategy={autoSizeStrategy}
            rowSelection={"single"}
          />
        </div>
      </div>
      <div className="extra-help">
        <div>
          <button
            className="download-csv"
            title="Download CSV"
            onClick={onBtnExport}>
            <FaFileDownload size={25} />
          </button>
        </div>

        <div className="help-icon-container">
          <button
            className="help-icon-button"
            title="Help"
            onClick={() => {
              handleOpenModal();
            }}>
            <BsQuestionCircleFill size={25} />
          </button>
        </div>
      </div>
      <ReactModal
        isOpen={showModal}
        contentLabel={"Column Header Explanantions"}
        style={{
          overlay: {},
          content: {
            width: "50%",
            height: "50%",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          },
        }}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        onRequestClose={handleCloseModal}>
        <div className="modal-explanation">
          <button onClick={handleCloseModal} className="modal-close-button">
            <span className="close">&times;</span>
          </button>
        </div>
        <div>
          <h3 style={{ textAlign: "center" }}>Legend</h3>
          <br />
          <p>
            <b>Student Files: </b> Files uploaded by students - these do not
            count towards course quota, but video homework is often best
            uploaded to Panopto.
          </p>
          <br />
          <p>
            <b>Course Files: </b> Files uploaded to the course by the instructor
            and subject to the quota requirement.
          </p>
           <br />
          <p>
            <b>Zipped Files: </b> This column displays the total size of compressed files in the course.
          </p>
          <br />
        </div>
      </ReactModal>
    </>
  );
};

export default DeptStorage;
